import { useReducer } from "react";

/**
 * from @link https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
 */
export const useForceUpdate = () => {
  const [, forceUpdate] = useReducer((value) => value + 1, 0);
  return forceUpdate;
};
